import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { TrendingDown, ChevronRight } from 'lucide-react';

const ClientesEmRiscoCard = () => {
  const navigate = useNavigate();
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    api.get('/dashboard/clientes-em-risco')
      .then(res => setClientes(res.data || []))
      .catch(() => setErro(true))
      .finally(() => setLoading(false));
  }, []);

  const critico = clientes.filter(c => c.tendencia === 'critico').length;
  const alerta  = clientes.filter(c => c.tendencia === 'alerta').length;
  const estavel = clientes.filter(c => c.tendencia === 'estavel').length;

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-red-50 rounded-lg flex items-center justify-center">
            <TrendingDown size={16} className="text-red-500" />
          </div>
          <div>
            <p className="text-sm font-black text-slate-800">Clientes em Risco</p>
            <p className="text-xs text-slate-400">Queda de faturamento &gt;25% vs. média 3 meses</p>
          </div>
        </div>
        <button onClick={() => navigate('/inteligencia-comercial')}
          className="flex items-center gap-1 text-xs font-black text-[#0A3D73] hover:opacity-70 transition-opacity">
          Ver detalhes <ChevronRight size={11} />
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-6">
          <div className="w-6 h-6 border-4 border-slate-200 border-t-[#0A3D73] rounded-full animate-spin" />
        </div>
      ) : erro ? (
        <div className="flex items-center justify-center py-6">
          <p className="text-sm text-red-500 font-semibold">Erro ao carregar dados</p>
        </div>
      ) : clientes.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-6 gap-1">
          <p className="text-sm font-black text-green-600">Nenhum cliente em risco</p>
          <p className="text-xs text-slate-400">Todos os clientes mantêm faturamento estável</p>
        </div>
      ) : (
        <div className="px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="flex-1 text-center bg-red-50 border border-red-200 rounded-lg py-3">
              <p className="text-2xl font-black text-red-600">{critico}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-red-400 mt-0.5">Risco Alto</p>
            </div>
            <div className="flex-1 text-center bg-orange-50 border border-orange-200 rounded-lg py-3">
              <p className="text-2xl font-black text-orange-500">{alerta}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-orange-400 mt-0.5">Risco Médio</p>
            </div>
            <div className="flex-1 text-center bg-green-50 border border-green-200 rounded-lg py-3">
              <p className="text-2xl font-black text-green-600">{estavel}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-green-400 mt-0.5">Risco Baixo</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientesEmRiscoCard;
